<template>
<!-- <v-list-tile href="javascript:;" @click="toggleSelected(id)"> -->
<div id="mySelect">
  <v-list-tile>
    <!-- <v-list-tile-action>

      <input type="checkbox" v-model="checkedItems" :value="id" @click="toggleCheckedItems(id)">
    </v-list-tile-action> -->

    <v-container fluid grid-list-md>
      <v-layout row wrap align-center>
        <v-list-tile-action>
          <input type="checkbox" v-model="checkedItems" :value="id" @click="toggleCheckedItems(id)">
        </v-list-tile-action>
        <avatar v-if="image !== null"
          username="JAne Doe"
          class="cursor-pointer"
          :src="image.split('?')[0]"
          :size="30" @click="selectPatient(person_id)">
        </avatar>
        <div v-else class="cursor-pointer" @click="selectPatient(person_id)">
          <i class="fas fa-user-circle fa-2x" style="color:lightgray"></i>
        </div>

        <v-flex xs2 class="cursor-pointer" @click="selectPatient(person_id)">
          <v-card class="pt pt-name">
            {{name}}
            <!-- {{order}} -->
          </v-card>
        </v-flex>
        <v-flex xs1 class="pt_info">
          <span v-if='gender === "Male"'>M</span>
          <span v-if='gender === "Female"'>F</span>
          <span v-if='gender === "Other"'>Other</span>
          <span>, {{age}}</span>
        </v-flex>
        <v-flex xs3>
          <router-link
          class="vitalsButton"
          :to="{
            name: 'vitalsPost',
            params: {status:`${vitals}`,
            appId: `${id}`,
            ptId: `${person_id}`} }">
            <el-button
            :class="(this.vitals === 'finished') ? 'button--vitals-success' : 'button--vitals-info'"
            @click="logInlocalStorage(billing,vitals,name,age,place,gender)"
            >
            Vitals</el-button>
          </router-link>
          <router-link :to="{ name: 'prescription', params: {appId: `${id}`,ptId: `${person_id}`} }" v-if='print !== "finished"'>
            <el-button
            class="button--prescription-info"
             @click="logInlocalStorage(billing,vitals,name,age,place,gender)">Prescription</el-button>
          </router-link>
          <router-link :to="{ name: 'prescription', params: {appId: `${id}`,ptId: `${person_id}`} }" v-else>
            <el-button
            class="button--prescription-success"
             @click="logInlocalStorage(billing,vitals,name,age,place,gender)">Prescription</el-button>
          </router-link>

          <router-link :to="{
            name: 'billingView',
            params: {
              appId: `${id}`,
              ptId: `${person_id}`
              }
            }"
            v-if='billing === "finished"'
            >
              <el-button
              class="button--billing-success"
              @click="logInlocalStorage(billing,vitals,name,age,place,gender)"
              >
              Billing
            </el-button>
          </router-link>

          <router-link
          :to="{
            name: 'billing',
            params: {
              appId: `${id}`,
              ptId: `${person_id}`
              }
            }"
            v-else
            >
                <el-button
                class="button--billing-info"
                @click="logInlocalStorage(billing,vitals,name,age,place,gender)"
                >
                Billing
              </el-button>
          </router-link>
        </v-flex>
        <!-- <v-flex xs1 class="text-xs-right">
        </v-flex> -->
        <v-flex xs5 v-if='critical !== 1'>
          <v-card
          class="pt pt-last-visit"
          v-if='lastVisit === "Newcomer"'>New Patient</v-card>
          <v-card class="pt pt-last-visit" v-else>Last visit: {{lastVisit}}</v-card>
        </v-flex>
        <v-flex xs5 v-else>

          <v-card
          class="pt pt-last-visit"
          v-if='lastVisit === "Newcomer"'>New Patient</v-card>
          <v-card class="pt pt-last-visit" v-else>Last visit: {{lastVisit}}</v-card>
          <span class="pt-critical">
            <span class="pulse"></span>
            {{criticalOn}}
          </span>
          <!-- <span class="pulse"></span> -->
          <!-- <i class="fas fa-circle"></i> -->
          <!-- • -->
          <!-- <v-card class="pt pt-critical">{{criticalOn}}</v-card> -->
        </v-flex>

      </v-layout>
    </v-container>
  </v-list-tile>
</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import _ from 'lodash';
import Avatar from 'vue-avatar';

export default {
  name: 'Patient',
  props: [
    'name',
    'gender',
    'age',
    'place',
    'lastVisit',
    'id',
    'order',
    'vitals',
    'person_id',
    'print',
    'billing',
    'critical',
    'criticalOn',
    'image',
    'selectPatient'
  ],
  components: {
    avatar: Avatar
  },
  computed: {
    ...mapState(['appointment_id']),
    // checkedItems: state => state.checkedItems,
    checkedItems: {
      get(v) {
        return this.$store.state.checkedItems;
      },
      set(value) {
        console.log('value from patient comp');
        this.$store.commit('toggle', {
          value,
          id: this.id
        });
      }
    }
  },
  data() {
    return {
      btnToggle: true
      // notifications: false,
    };
  },
  mounted() {},
  methods: {
    logInlocalStorage(billing, vitals, name, age, place, gender) {
      // if(this.checkedItems.length==0){
      // /* ! Warn If User selected any pt then don't allow them to next page So don't upate localStorage*/
      //   return
      // }
      localStorage.setItem('from_where', 'WaitingList');
      localStorage.setItem('billingStatus', this.billing);
      localStorage.setItem('vitalsStatus', this.vitals);
      localStorage.setItem('ptName', this.name);
      localStorage.setItem('ptAge', this.age);
      localStorage.setItem('ptPlace', this.place);
      localStorage.setItem('ptGender', this.gender);
    },
    test(id) {
      this.$store.state.appointment_id = this.id;
      this.$router.push('/prescription');
    },
    ...mapMutations(['toggleCheckedItems'])
  }
};
</script>
<style scoped>
.pt-head {
  /* flex-direction: row; */
  /* justify-content: space-between; */
}

.pt {
  font-family: 'Assistant', sans-serif;
  color: #4e4e4e;
  font-weight: 300;
  /* max-width: 100px; */
}

.pt::first-letter {
  text-transform: uppercase;
}

/* .pt-name {
  font-size: 1.2rem;
  font-weight: 600;
} */

.pt-name {
  color: #484848;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.13px;
  line-height: 23px;
  padding-left: 0.2rem;
}

.pt-age,
.pt-gender,
.pt-city {
  opacity: 0.8;
  color: gray;
  font-size: 1.2rem;
}

.pt-last-visit {
  /* color:#000; */
}
.pt-critical {
  font-size: 0.8rem;
  display: block;
  color: red;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: -webkit-fill-available;
}
.pt_info {
  color: #aeaeae;
  font-weight: 400;
}

#completed .vitalsButton {
  pointer-events: none;
  opacity: 0.6;
}

/* pulsate css animation begin*/
.pulse {
  display: inline-flex;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: red;
  cursor: pointer;
  box-shadow: 0 0 0 rgba(204, 169, 44, 0.4);
  margin-right: 2px;
  /* animation: pulse 2s infinite; */
}
.pulse:hover {
  animation: none;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }
  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.4);
  }
  70% {
    -moz-box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 10px rgba(204, 169, 44, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0);
  }
}
/* pulsate css animation end*/
.button--vitals-success {
  color: #fff;
  border: 0px;
  border-color: #f2994a;
  background-color: #f2994a;
}

.button--vitals-info,
.button--prescription-info,
.button--billing-info {
  color: #fff;
  border: 0px;
  border-color: #d0d0d0;
  background-color: #d0d0d0;
}
.button--billing-info {
  visibility: hidden;
}
.button--prescription-success {
  color: #fff;
  border: 0px;
  border-color: rgb(50, 175, 111);
  background-color: rgb(50, 175, 111);
}
.button--billing-success {
  color: #fff;
  border: 0px;
  border-color: #5d6be8;
  background-color: #5d6be8;
}
/* .button--prescription-info {
  color: #fff;
  border: 0px;
  border-color: #252424;
  background-color: #252424;
} */
input[type='checkbox'] {
  -webkit-appearance: none;
  border-radius: 2em;
  position: relative;
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 1rem;
  border: 1px solid rgba(158, 158, 158, 0.52);
}
input[type='checkbox']:checked {
  background: #018fff
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath d='M.04.627L.146.52.43.804.323.91zm.177.177L.854.167.96.273.323.91z' fill='%23fff'/%3E%3C/svg%3E")
    no-repeat 50%;
  background-size: 70%;
}
</style>



// WEBPACK FOOTER //
// src/components/Patient.vue